import { Button } from 'antd';
import styled from 'styled-components';

export const MathButtonWrapper = styled(Button)`
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: center;
`;
